import { map } from "rxjs";
import { LinkedAccount } from "../../model";
import apiService from "../ApiService";

export const getLinkedAccounts = () => {
  return apiService
    .get<{ linkedAccounts: LinkedAccount[] }>({
      path: `v1/me/linkedaccounts`,
    })
    .pipe(map((e) => e.linkedAccounts));
};
